import React, { useEffect, useState } from "react";
import { NAV_LINKS } from "../data/content";
import PogLogo from "./PogLogo";
import { Instagram } from "lucide-react";

const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#14100D]/85 backdrop-blur-xl border-b border-[#EFE7D6]/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-12 py-6 flex items-center justify-between">
        <button
          onClick={() => scrollTo("hero")}
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <PogLogo size={30} />
          <span className="hidden sm:inline-block font-body text-[#EFE7D6] tracking-wide text-lg">
            Spirits
          </span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="font-body text-[11px] tracking-[0.28em] uppercase text-[#EFE7D6]/75 hover:text-[#E85A15] transition-colors link-underline"
            >
              {l.label}
            </button>
          ))}
          <a
            href="/journal"
            data-testid="nav-link-journal"
            className="font-body text-[11px] tracking-[0.28em] uppercase text-[#EFE7D6]/75 hover:text-[#E85A15] transition-colors link-underline"
          >
            Journal
          </a>
        </div>

        <div className="flex items-center gap-4">
          <a
            href="https://www.instagram.com/pogspirits"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="POG Spirits on Instagram (@pogspirits)"
            data-testid="nav-instagram"
            className="text-[#EFE7D6]/75 hover:text-[#E85A15] transition-colors"
          >
            <Instagram size={18} strokeWidth={1.5} />
          </a>
          <button
            onClick={() => scrollTo("inquire")}
            data-testid="nav-inquire-button"
            className="btn-ghost text-[10px] px-6 py-3"
          >
            Inquire
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
